import type { CustomerModel } from "@/models";
import {
    ageRule,
    dayPhoneRule,
    dobDateRule,
    dobMonthRule,
    dobYearRule,
    emailRule,
    firstnameRule,
    fullDobRule,
    middlenameRule,
    smokerRule,
    staffIdRule,
    surnameRule,
    titleRule,
} from "@/validation";

export const getQuoteRules = (customer: CustomerModel) => {
    return {
        customer: {
            age: ageRule,
            dobDate: dobDateRule,
            dobMonth: dobMonthRule,
            dobYear: dobYearRule,
            fullDob: fullDobRule(customer),
            dayPhone: dayPhoneRule(),
            title: titleRule(customer),
            firstname: firstnameRule(customer),
            middlename: middlenameRule,
            surname: surnameRule(customer),
            email: emailRule,
            smoker: smokerRule,
        },
        journey: {
            staffId: staffIdRule,
        },
    };
};
